window.parallaxClose = false;
window.editorImage = false;
window.insertToWys = false;
window.imeload = false; // ime == image editor
window.AjaxImgLoad = false;

(function ($) {
    RVwys.cleanImageEditor = function () {
        if ($('#frameBody').get(0)) {
            $('#frameBody').contents().find('.image-editor-tool').hide();
        } else {
            $('.image-editor-tool').hide();
        }
    };
    RVwys.CleanImageEditorToolBody = function () {
        $(document)
            .unbind('click', RVwys.cleanImageEditor)
            .bind('click', RVwys.cleanImageEditor);
        $('#wys-PageSetting')
            .unbind('click', RVwys.cleanImageEditor)
            .bind('click', RVwys.cleanImageEditor);
    };

    wys.event('imageWidget:mousedown', function (e) {
        console.log('call->imageWidget:mousedown');
        console.log($(e.target).get(0));
        //return false;
    });
    /*
	wys.addEvent('imageWidget:mousedown',function(e){

		console.log('imageWidget');
		console.log($(e.target).get(0));
		return false;
	})
*/
    $(document).bind('editorReady', function () {
        parent.RVwys.CleanImageEditorToolBody();
    });

    var imgEditor = {};
    imgEditor.editOject = false;

    imgEditor.convertFileToDataURLviaFileReader = function (url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    imgEditor.getBase64Image = function (img) {
        try {
            img.get(0).setAttribute('crossOrigin', 'anonymous');

            var canvas = document.createElement('canvas');
            canvas.width = img.width();
            canvas.height = img.height();
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img.get(0), 0, 0);
            var dataURL = canvas.toDataURL('image/jpg');
            return dataURL;
        } catch (e) {
            console.log(e);
            //alert(e)
            return false;
        }
    };
    RVwys.imageEditorToolResetPos = function () {
        if (parent.$('.image-editor-tool').is(':visible')) {
            var po = curImage.offset();
            var poLeft =
                po.left +
                (curImage.width() / 2 - $('.image-editor-tool').width() / 2);
            var poTop =
                po.top +
                (curImage.height() / 2 - $('.image-editor-tool').height() / 2);
            $('.image-editor-tool').css({ left: poLeft, top: poTop });
        }
    };
    RVwys.imageEditorEventmUp = function (e) {
        var curRangeTag = e.target ? $(e.target) : e;
        if (curRangeTag.hasClass('borderResize')) {
            var sel = RVwys.currentEditor.getSelection();
            sel.removeAllRanges();
            var newSel = RVwys.currentEditor.createRange();
            newSel.selectNode(curImage.get(0));
            sel.addRange(newSel);
            curRangeTag = curImage;
        }
        var tag = curRangeTag.get(0).tagName.toLowerCase();
        if (tag == 'img') {
            if (
                !curRangeTag
                    .get(0)
                    .className.match(
                        /(jotForm|fbComment|fbLikebox|fbLikebutton|fbpageplugin|video_youtube|insertwidget)/gim
                    )
            ) {
                var rDivHIMG = $('<div></div>').append(curRangeTag.clone());
                parent.ObjectImage = rDivHIMG.html();
                rDivHIMG.remove();

                $(
                    '.image-editor-tool, #imedit-reEdit,#imedit-rechoose,#imedit-edit'
                ).show();
                curImage = curRangeTag;
                parent.focusImage = curImage;
                var po = curRangeTag.offset();
                // alert(curRangeTag.height())

                /*
                 * Apiruk var imgTag = curRangeTag.get(0); var imgGetSrc =
                 * imgTag.getAttribute('src'); var currentDomain =
                 * document.location.protocol + '//' + document.location.host;
                 * imgGetSrc = imgGetSrc.replace(currentDomain,''); //Apiruk
                 * console.log('<img src = ' + imgGetSrc); //console.log('<img
                 * currentDomain = ' + currentDomain);
                 * //console.log('====================='); //case: external link
                 * and broken img Hide crop icon if
                 * (imgGetSrc.match(/^http|no\-image\.jpg/img)) {
                 * $('.image-editor-tool').find('#imedit-reEdit').hide(); }
                 */

                var widthS = parseInt(curRangeTag.width());
                var heightS = parseInt(curRangeTag.height());
                if (parent.$('#imageLib').is(':visible')) {
                    $('.image-editor-tool')
                        .find('#imedit-reEdit,#imedit-rechoose,#imedit-edit')
                        .hide();

                    // current image manager
                    RVwys.currentImageManager(curImage, 'active');
                } else {
                    var poLeft =
                        po.left +
                        (curRangeTag.width() / 2 -
                            $('.image-editor-tool').width() / 2);
                    var poTop =
                        po.top +
                        (curRangeTag.height() / 2 -
                            $('.image-editor-tool').height() / 2);
                    $('.image-editor-tool').css({ left: poLeft, top: poTop });
                }

                if (heightS < 50) {
                    $('.image-editor-tool').hide();
                }

                if (widthS < 130) {
                    $('.image-editor-tool').hide();
                }
            }
        } else {
            parent.ObjectImage = '';
        }
    };
    RVwys.getBase64ImageThumbnail = function (img) {
        var canvas = document.createElement('canvas');
        var scale = 115;
        var ratio = RVwys.imagemanager.getRatioThumbnail(img, scale);
        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, scale, img.height * ratio);
        var dataURL = canvas.toDataURL('image/jpg');

        $(canvas).remove();
        return dataURL;
    };

    RVwys.imageReEditParent = function (input) {
        $('#frameBody').get(0).contentWindow.curImage.imageReEdit(input);
    };
    RVwys.imageReChoose = function (input) {
        $('#frameBody').get(0).contentWindow.curImage.imageReChoose(input);
    };
    RVwys.imageUpload = function (input) {
        $('#frameBody').get(0).contentWindow.curImage.imageUpload(input);
    };
    RVwys.imageReChooseSection = function (input) {
        // RVwys.fixBlockTools();
        console.log(parent.aFreeImages);
        // parent.focusImage = curImage;
        // RVwys.imagemanager.show();
        //set positon
        var sectionActive = $('.mgActive').get(0)
            ? $('.mgActive')
            : $('#frameBody').get(0).contentWindow.$('.mgActive');

        var rowFour = parent.$('.wys-rowFour');

        if (parent.isBlockBG) {
            rowFour = parent.$('.wys-rowThree');
            sectionActive = parent.RVwys.getBlockBG;
        }

        var imageLib = parent.$('.imageLib');
        var posRowFour = rowFour.position();
        var posLeft = posRowFour.left - (imageLib.width() - 11);
        var posTop = posRowFour.top;

        if (posLeft < 0) {
            posLeft = '860px'; //imageLib.position().left;
        }

        imageLib.show().css({
            left: posLeft,
            top: posTop,
        });

        parent.$('.wys-rowTwo, .wys-dynamic, .widget-blocks').hide();
        var isCssRGBA = sectionActive.css('background-color');
        var src = sectionActive.parent().css('background-image');
        RVwys.currentImageManager(src, 'active');
        $('.image-editor-tool')
            .find('#imedit-reEdit,#imedit-rechoose,#imedit-edit')
            .hide();
    };

    RVwys.imageBGReChoose = function (input) {
        isSectionBG = true;
        isSiteBG = false;
        isBlockBG = false;
        // setTimeout(function(){
        $('#frameBody').get(0).contentWindow.RVwys.imageReChooseSection(input);
        // },500)
    };

    RVwys.imageBGReChooseBlock = function (input) {
        isSectionBG = true;
        isSiteBG = false;
        isBlockBG = true;
        // setTimeout(function(){
        $('#frameBody').get(0).contentWindow.RVwys.imageReChooseSection(input);
        // },500)
    };
    RVwys.imageBGUpload = function (input) {
        isSectionBG = true;
        RVwys.fixBlockTools();
        $('#testssd').remove();
        var fileType = ['.jpg', '.jpeg', '.bmp', '.gif', '.png'];
        var pat = new RegExp('(' + fileType.join('|') + ')$', 'img');
        var isFileType = pat.exec($(input).val());
        if (!isFileType) {
            var UI = parent.UIkit;
            var onInsert = function (e) {
                $('#imedit-upload').val('');
                parent.$('#imedit-upload').val('');
                modal.hide();
            };
            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Upload image') +
                        '</h2></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        rvLang('file type not support.') +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Ok') +
                        '</button>',
                    '</div>',
                ].join(''),
                options
            );
            modal.element.find('.uk-button-success').on('click', function () {
                onInsert();
            });
            modal.show();
            $(input).val('');
            return false;
        }

        $('.imgEditor').hide();
        var sectionActive = $('#frameBody').get(0).contentWindow.$('.mgActive');
        parent.$('body').prepend(
            $('<div class="overlaypanel"></div>').css({
                width: parent.$('#topbar').width() + 1,
                height: parent.$('#topbar').height() + 1,
            })
        );
        var overlaypanel = $('<div class="overlaypanel"></div>').css({
            width: $('body').width(),
            height: $('body').height(),
        });

        $('body').prepend(overlaypanel);
        parent.RVwys.hidePanelAll();
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            var getThis = $(this);
            reader.onload = function (e) {
                $(input).val('');
                var image = new Image();
                image.src = e.target.result;

                image.onload = function () {
                    // access image size here
                    console.log(this.width);

                    $('.overlaypanel').remove();
                    if (this.width > 1601) {
                        var scale = this.width; //1600;
                        var ratio = RVwys.imagemanager.getRatioThumbnail(
                            this,
                            scale - 600
                        );
                        var canvas = document.createElement('canvas');
                        canvas.width = this.width * ratio;
                        canvas.height = this.height * ratio;
                        var ctx = canvas.getContext('2d');
                        ctx.scale(
                            scale / canvas.width,
                            (this.height * ratio) / canvas.height
                        );
                        // ctx.drawImage(this, 0, 0);
                        ctx.drawImage(this, 0, 0, scale, this.height * ratio);
                        var dataURL = canvas.toDataURL('image/' + isFileType);
                        // $('body').append('<img id="testssd"
                        // src="'+dataURL+'">');
                    } else {
                        var canvas = document.createElement('canvas');
                        canvas.width = this.width;
                        canvas.height = this.height;
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(this, 0, 0, this.width, this.height);
                        var dataURL = canvas.toDataURL('image/' + isFileType);
                        // $('body').append('<img id="testssd"
                        // src="'+dataURL+'">');
                    }

                    // upload

                    var overlaypanel = $(
                        '<div class="overlaypanel"><p class="progressFB">' +
                            rvLang('copy to My image') +
                            '</p></div>'
                    ).css({
                        width: $('body').width(),
                        height: $('body').height(),
                    });

                    $('body').prepend(overlaypanel);

                    var canvasThumb = document.createElement('canvas');
                    var scale = 115;
                    var ratio = RVwys.imagemanager.getRatioThumbnail(
                        this,
                        scale
                    );
                    canvasThumb.width = this.width * ratio;
                    canvasThumb.height = this.height * ratio;
                    var ctxcanvasThumb = canvasThumb.getContext('2d');
                    ctxcanvasThumb.drawImage(
                        this,
                        0,
                        0,
                        scale,
                        this.height * ratio
                    );
                    var thumbnail = canvasThumb.toDataURL('image/' + imageType);
                    $(canvasThumb).remove();

                    var imageType = dataURL
                        .replace(/^data\:image\//gim, '')
                        .replace(/\;base64(.*)/gim, '');
                    if (this.src.match(/^data:image/)) {
                        // var imageType =
                        // (data.toDataURL('image/'+imageType)).replace(/^data\:image\//img,'').replace(/\;base64(.*)/img,'');
                        var d = new Date();
                        var n = d.getTime();
                        var imageURL = '';
                        var imageName = n + '.' + imageType;
                    }

                    var sendImage = {
                        send: {
                            data: dataURL,
                            thumnail: thumbnail,
                            imageURL: imageURL,
                            override: 0,
                            imageName: imageName,
                            imageType: imageType,
                            tagFolder: '',
                        },
                    };

                    RVwys.imagemanager.uploadImage(sendImage, function (URL) {
                        if (parent.rowParallaxSlide) {
                            var fb = $('#frameBody').get(0).contentWindow;
                            var slideActive = $('#frameBody')
                                .get(0)
                                .contentWindow.$('.uk-slideshow>.uk-active')
                                .children('.uk-cover-background');
                            var isCssRGBA = slideActive.css('background-color');
                            // alert(sectionActive.parent().css('background-color'))
                            var validateRGB = {
                                'rgb(': true,
                                'rgba(0,0,0,0)': true,
                            };
                            if (isCssRGBA == '') {
                                repairRGBA = 'rgba(255,255,255,.2)';
                            }
                            repairRGBA = isCssRGBA.replace(
                                /rgb\((.*?)\)/gim,
                                'rgba($1,.2)'
                            );
                            slideActive.css('background-color', repairRGBA);

                            slideActive.css({
                                'background-image': 'url(' + URL + ')',
                                'background-repeat': 'no-repeat',
                                'background-size': 'cover',
                            });

                            var slideActiveIMG = $('#frameBody')
                                .get(0)
                                .contentWindow.$('.uk-slideshow>.uk-active')
                                .children('img');
                            slideActiveIMG.attr('src', URL);

                            var mg = fb.$('#rvs-uk-slide');
                            mg.find('.uk-cover-background').remove();
                            mg.find('.uk-slideshow-ghost').remove();
                            var mgClone = mg.clone();
                            mg.after(mgClone);
                            mg.remove();

                            setTimeout(function () {
                                //UIkit.slideshow(mgClone);
                            }, 200);
                        } else {
                            isCssRGBA = sectionActive.css('background-color');
                            // alert(sectionActive.parent().css('background-color'))
                            var validateRGB = {
                                'rgb(': true,
                                'rgba(0,0,0,0)': true,
                            };
                            if (isCssRGBA == '') {
                                repairRGBA = 'rgba(255,255,255,.2)';
                            }
                            var repairRGBA = isCssRGBA.replace(
                                /rgb\((.*?)\)/gim,
                                'rgba($1,.2)'
                            );
                            sectionActive.css('background-color', repairRGBA);

                            sectionActive.parent().css({
                                'background-image': 'url(' + URL + ')',
                                'background-repeat': 'no-repeat',
                                'background-size': 'cover',
                                'background-attachment': 'fixed',
                            });
                        }

                        // display them
                    });
                };
            };
            reader.readAsDataURL(input.files[0]);
        } else {
            swal("Sorry - you're browser doesn't support the FileReader API");
        }
    };

    RVwys.currentImageManager = function (curImage, active) {
        // current image manager
        var imageSRC =
            (typeof curImage).toLowerCase() == 'object'
                ? curImage.attr('src')
                : curImage;
        var aImageName =
            (typeof imageSRC).toLowerCase() == 'string'
                ? imageSRC.split('/')
                : '';
        //alert(aImageName)
        var imageName =
            aImageName != 'none' && aImageName != ''
                ? aImageName[aImageName.length - 1].replace(/\?(.*)/gim, '')
                : imageSRC;
        var imageName = imageName.replace(/\(|\)|\"/gm, '');
        var imgtabActive = 0;

        if (!imageSRC.match(/(?:imageslibrary_v6|rvs_library)/gim)) {
            imgtabActive = 4;
            imageName = 'my' + imageName.replace('.', '\\.');
            var imgcontainer = '.imageBoxView-myimage';
        } else {
            imageName = imageName.replace('.', '-dot-');
            var imgcontainer = '.imageBoxView-free';
        }

        if (imageSRC.match(/(?:freebackground)/gim)) {
            var nameImg = aImageName[aImageName.length - 1].match(/[0-9]/g);
            imageName =
                'img_' +
                aImageName[aImageName.length - 3] +
                '_' +
                aImageName[aImageName.length - 2] +
                '_' +
                nameImg;
            imgtabActive = 1;
        }

        if (active) {
            parent.$('#imageLib-tabs').tabs('option', 'active', imgtabActive);
        }

        if (imgtabActive == 0) {
            if (parent.$('.imageBoxView-free').html() == '') {
                if (processListFreeImage) {
                    clearTimeout(processListFreeImage);
                }
                RVwys.imagemanager.addView(parent.aFreeImages, 'all');
            }
        }
        parent.$('.rvCurrentImage').removeClass('rvCurrentImage');
        var imgFoCus = parent.$('#' + imageName).addClass('rvCurrentImage');

        if (imgFoCus.get(0)) {
            if (active) {
                var offsetTop =
                    parent.$(imgcontainer).scrollTop() +
                    imgFoCus.offset().top -
                    189;
                parent.$(imgcontainer).animate(
                    {
                        scrollTop: offsetTop,
                    },
                    {
                        complete: function () {
                            setTimeout(function () {
                                parent
                                    .$('.ui-tabs-animateOut')
                                    .addClass('ui-tabs-animate')
                                    .removeClass('ui-tabs-animateOut');
                            }, 50);
                        },
                    }
                );
            }
        }
    };
    RVwys.parallaxStopEvent = function () {
        console.log('window scroll false');
        return false;
    };
    RVwys.parallaxStop = function () {
        // alert(UIkit.checkParallaxes)
        // UIkit.$doc.on("scrolling.uk.document",RVwys.parallaxStopEvent);

        curImage.closest('.RVWYSIWYGAREA').css({ transform: '' });
        $('body').css('overflow', 'hidden');
        parallaxClose = true;
    };
    RVwys.parallaxStart = function () {
        $('body').css('overflow', '');
        RVwys.fixBlockToolsRelative();
        parallaxClose = false;
    };

    RVwys.imageEditorFullAndInsert = function (imageURL) {
        parent.insertToWys = true;
        RVwys.buildImageToolFull(imageURL);
    };

    RVwys.imageEditorFull = function (imageURL) {
        parent.insertToWys = false;
        RVwys.buildImageToolFull(imageURL);
    };
    RVwys.loadImageFromURL = function (imageURL) {
        var fM = parent.$('#imageEditorFull').get(0).contentWindow;
        var fb = parent.$('#frameBody').get(0).contentWindow;
        var filename = imageURL.substring(imageURL.lastIndexOf('/') + 1);
        console.log('fM');
        console.log(fM);
        console.log('fM.imageEditor: ', imageEditor);
        var d = new Date();
        var n = d.getTime();
        imageURL = imageURL.replace(/\?n=\w*/gim, '') + '?n=' + n;
        imageEditor.loadImageFromURL(imageURL, filename).then(() => {
            try {
                fM.imageEditor.clearUndoStack();
            } catch (e) {}
            var fime = parent.$('#imageEditorFull').get(0).contentWindow;
            fime.$('.loading').hide();

            $('.overlaypanel').remove();

            parent.$('.overlaypanel').remove();
            $('.overlay-image').remove();
            fb.$('.overlaypanel').remove();
            parent.$('.overlay-image').remove();
        });
        //$('.overlaypanel,.overlaypanelfullimage').remove();
        parent.$('.wys-imageEditFull').show();
        //fb.$('.overlaypanel,.overlaypanelfullimage').remove();
    };
    RVwys.resetActiveImageEditorFull = function (imageURL) {
        var fM = parent.$('#imageEditorFull').get(0).contentWindow;
        fM.$('.active').removeClass('active');
        fM.$('#textSizeRange').val(10);
        fM.$('#textSizeRange-value').html(10);
        fM.$('#configRotationRange').val(0);
        fM.$('#configRotationNumber').val(0);
        fM.$('#btn-Brightness').val(0);
        fM.$('#btn-Brightness-value').html(0);
        fM.$('#btn-Contrast').val(0);
        fM.$('#btn-Contrast-value').html(0);
    };
    RVwys.buildImageToolFull = function (imageURL) {
        var fb = parent.$('#frameBody').get(0).contentWindow;
        console.log('full frame');
        console.log(fb);
        console.log(fb.contentWindow);
        console.log(fb.contentDocument);
        console.log(window);
        //alert(window.performance.timing)
        console.log('---------');
        console.log(fb);

        //curImage.removeAttr('width');
        //curImage.removeAttr('height');
        //    		    		curImage.css({
        //    		    				"width":"",
        //    		    				"height":""
        //    		    				});
        $('#selected_headerbanner').removeAttr('style');

        //$('.img-cancel').trigger( "click" );
        if (!parent.$('#imageEditorFull').get(0)) {
            var path =
                parent.wex.url.baseUrl + '/admin/wysiwyg/uikit/imageeditor';
            var editorfull = $(
                '<iframe id="imageEditorFull" name="imageEditorFull"  src="' +
                    path +
                    '" width="100%" height="' +
                    $(document).height() +
                    '"></iframe>'
            ).on('load', function (e) {
                console.log('imageEditorFull');
                console.log(e);

                RVwys.loadImageFromURL(imageURL);
                RVwys.resetActiveImageEditorFull();
            });
            //alert($(document).height());
            parent.$('#image-editorfull').append(editorfull);
        } else {
            RVwys.loadImageFromURL(imageURL);
            RVwys.resetActiveImageEditorFull();
        }
    };
    RVwys.disableSlideshow = function () {
        var uks = $('.uk-slideshow');
        uks.addClass('uk-slideshow-disabled').removeClass('uk-slideshow');
    };
    RVwys.enableSlideshow = function () {
        var uks = $('.uk-slideshow-disabled');
        uks.addClass('uk-slideshow').removeClass('uk-slideshow-disabled');
    };
    RVwys.imageEditorLoad = function () {
        $('.overlaypanel').append(
            $(
                '<div ' +
                    'class="ldBar label-center image-editor-load" data-value="0"' +
                    'data-preset="circle"></div>'
            )
        );
        imeload = new ldBar($('.image-editor-load').get(0), {
            stroke: '#FFF',
        });
        return imeload;
    };
    RVwys.imageEditorLoadIFN = function () {
        //		oly = $('.overlaypanelfullImage').append($('<img class="loading" src="'
        //			+ parent.wex.url.rvsThemImage
        //			+ 'loading08.gif" width="32" height="32" border="0" align="absmiddle" />'
        //			+'</div>'));
        //
        var oly = $(
            '<div class="overlaypanelfullimage">' +
                '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                '</div>'
        );

        var parentoly = oly.clone().find('img').remove().end();
        //parent.$('body').prepend(parentoly.css({'width':parent.$('#topbar').width(),'height':parent.$('#topbar').height()}));
        //$('body').prepend(oly.css({'width':$(document).width(),'height':$(document).height()}));
    };
    imgEditor.onError = function () {
        var UI = parent.UIkit;
        var onInsert = function (e) {
            modal.hide();
            parent.$('.overlaypanel').remove();
            $('.overlaypanel').remove();
        };
        var options = {
            bgclose: false,
            keyboard: false,
            modal: false,
        };

        var modal = UI.modal.dialog(
            [
                '<div class="uk-margin uk-modal-header "><h2>' +
                    rvLang('Edit image error') +
                    '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                '<div class="uk-margin msgblock-error">' +
                    rvLang(
                        'url Image Error.(external url. or this image removed)'
                    ) +
                    '</div>',
                '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                    rvLang('Ok') +
                    '</button>',
                '</div>',
            ].join(''),
            options
        );
        // click OK close todo
        modal.element.find('.uk-button-success').on('click', function () {
            parent.editorImage = false;
            RVwys.parallaxStart();
            console.log('click OK: modal.hide()');
            onInsert();
        });
        // click button close todo remove modal
        modal.element.find('.uk-modal-close').on('click', function () {
            parent.editorImage = false;
            RVwys.parallaxStart();
            console.log('click close: modal.hide()');
            onInsert();
        });

        modal.show();
        parent.$('.overlaypanel').remove();
    };

    imgEditor.init = function (name, src, fix = false) {
        parent.editorImage = true;
        if (!fix) {
            curImage.css({
                width: curImage.attr('defaultWidth'),
                height: curImage.attr('defaultHeight'),
            });
        }
        // close parallax
        RVwys.parallaxStop();
        // validate image editor
        if (src.match(/http/gim)) {
            var data = imgEditor.getBase64Image(curImage);

            // imgEditor.init(name,data);
            if (!data) {
                imgEditor.onError();
                return false;
            }
        } else {
            // imgEditor.init(name,curImage.get(0).src)
        }
        var naturalImage = new Image();
        naturalImage.src = src;
        var pat = new RegExp('^data:image/([^;]*);', 'img');
        var isHeadImage = pat.exec(src);
        var imageType =
            isHeadImage != null && isHeadImage[1] ? isHeadImage[1] : 'jpg';
        if (imageType == 'jpeg') {
            imageType = 'jpg';
        }
        naturalImage.onerror = function () {
            $('.overlaypanel').remove();
            parent.$('.overlaypanel').remove();
            $('.overlay-image').remove();
            parent.$('.overlay-image').remove();
            if (!fix) {
                imgEditor.onError();
                return false;
            }
            curImage.attr('srcNew', curImage.attr('src'));
            imgEditor.init(name, curImage.attr('src'), fix);
        };
        naturalImage.onload = function () {
            var oDefault = {};
            // data.src+'?n='+n+'set';
            // RVwys.history.add();
            console.log('width:' + curImage.width());
            console.log('height:' + curImage.height());
            console.log('defaultWidth:' + curImage.attr('defaultWidth'));
            console.log('defaultHeight:' + curImage.attr('defaultHeight'));
            oDefault.src = this.src.replace(/\?n(?:.*?)set/gim, '');
            oDefault.srcdefault = curImage.attr('srcdefault');
            var setw, seth;
            if (!fix) {
                setw = curImage.attr('defaultWidth');
                seth = curImage.attr('defaultHeight');
            } else {
                setw = curImage.width();
                seth = curImage.height();
            }
            oDefault.width = setw;
            oDefault.height = seth;
            oDefault.left = curImage.position().left;
            oDefault.top = curImage.position().top;
            // alert(oDefault.height)
            // alert(oDefault.button.html())

            var s = curImage.cropper({
                viewMode: 3,
                dragMode: 'move',
                autoCropArea: 1,
                strict: false,
                restore: false,
                modal: false,
                guides: false,
                highlight: false,
                cropBoxMovable: false,
                cropBoxResizable: false,
                // aspectRatio: curImage.width()/curImage.height(),
                toggleDragModeOnDblclick: false,
                minContainerHeight: oDefault.height,
                minContainerWidth: oDefault.width,
                minCanvasWidth: oDefault.width,
                minCanvasHeight: oDefault.height,
                ready: function () {
                    // alert(fix)

                    oDefault.button = $(parent.$('#imageEditortpl').html());
                    if (fix) {
                        // alert('trusse')
                        oDefault.button
                            .find('.oriSize')
                            .attr('checked', 'checked');
                    } else {
                        oDefault.button.find('.oriSize').remove('checked');
                    }
                    oDefault.button
                        .find('.imgEditor')
                        .css({ display: '' })
                        .end()
                        .find('.cropper-icon-image-editor')
                        .click(function () {
                            //alert('ssss')
                        })
                        .end()
                        .find('.img-done')
                        .click(function () {
                            RVwys.parallaxStart();
                            var data = curImage.cropper('getCroppedCanvas');

                            curImage.cropper('destroy');
                            RVwys.enableSlideshow();
                            curImage.attr(
                                'src',
                                data.toDataURL('image/' + imageType)
                            );

                            // var sendData ={'data':e.target.result}
                            var sel = RVwys.currentEditor.getSelection();
                            sel.removeAllRanges();
                            var overlayImg = $(
                                '<div class="overlay-image"><div class="msgupload-image"></div></div>'
                            ).css({
                                width: curImage.attr('defaultWidth'),
                                height: curImage.attr('defaultHeight'),
                                top: curImage.offset().top,
                                left: curImage.offset().left,
                            });

                            curImage.after(overlayImg);

                            RVwys.imageEditorLoad();
                            $(this).is(':checked');
                            var img = new Image();
                            img.src = data.toDataURL('image/' + imageType);

                            var isOverride = $(this)
                                .parent()
                                .find('#overrideImage')
                                .is(':checked');
                            parent.editorImage = false;
                            img.onload = function () {
                                var canvasThumb = document.createElement(
                                    'canvas'
                                );
                                var scale = 115;
                                var ratio = RVwys.imagemanager.getRatioThumbnail(
                                    this,
                                    scale
                                );
                                canvasThumb.width = img.width * ratio;
                                canvasThumb.height = img.height * ratio;
                                var ctxcanvasThumb = canvasThumb.getContext(
                                    '2d'
                                );
                                ctxcanvasThumb.drawImage(
                                    img,
                                    0,
                                    0,
                                    scale,
                                    img.height * ratio
                                );
                                var thumbnail = canvasThumb.toDataURL(
                                    'image/' + imageType
                                );
                                $(canvasThumb).remove();

                                var canvasReal = document.createElement(
                                    'canvas'
                                );
                                var ratioReal = img.width / curImage.width();
                                canvasReal.width = curImage.width();
                                canvasReal.height = curImage.height();
                                var ctxcanvasReal = canvasReal.getContext('2d');
                                ctxcanvasReal.drawImage(
                                    img,
                                    0,
                                    0,
                                    curImage.width(),
                                    img.height / ratioReal
                                );
                                var imageData = canvasReal.toDataURL(
                                    'image/' + imageType
                                );

                                if (oDefault.src.match(/^data:image/)) {
                                    // var imageType =
                                    // (data.toDataURL('image/'+imageType)).replace(/^data\:image\//img,'').replace(/\;base64(.*)/img,'');
                                    var d = new Date();
                                    var n = d.getTime();
                                    var imageURL = '';
                                    var imageName = n + '.' + imageType;
                                } else {
                                    var imageURL = oDefault.src;
                                    var aImageName = oDefault.src.split('/');
                                    var imageName = aImageName[
                                        aImageName.length - 1
                                    ].replace(/\?(.*)/gim, '');
                                }

                                var sendImage = {
                                    image: curImage,
                                    overlay: overlayImg,
                                    send: {
                                        data: imageData,
                                        thumnail: thumbnail,
                                        imageURL: imageURL,
                                        override: isOverride,
                                        imageName: imageName,
                                        imageType: imageType,
                                        tagFolder: '',
                                    },
                                };
                                uploadImage(sendImage);
                            };
                        })
                        .end()
                        .find('.img-cancel')
                        .click(function () {
                            parent.editorImage = false;
                            RVwys.parallaxStart();
                            $('#imedit-upload').val('');
                            curImage.cropper('destroy');
                            $('.rv-zindex-auto').removeClass('rv-zindex-auto');
                            RVwys.enableSlideshow();
                            curImage.attr('src', oDefault.srcdefault);

                            curImage.removeAttr('srcNew');
                            curImage.removeAttr('srcdefault');
                            curImage.removeAttr('defaultWidth');
                            curImage.removeAttr('defaultHeight');
                            //curImage.removeAttr('width');
                            //curImage.removeAttr('height');
                            //    		    		curImage.css({
                            //    		    				"width":"",
                            //    		    				"height":""
                            //    		    				});
                            $('#selected_headerbanner').removeAttr('style');

                            $('.overlaypanel').remove();
                            parent.$('.overlaypanel').remove();
                            $('.overlay-image').remove();
                            parent.$('.overlay-image').remove();
                        })
                        .end()
                        .find('.img-zoomIn')
                        .click(function () {
                            RVwys.fixBlockTools();
                            curImage.cropper('zoom', '0.1');
                        })
                        .end()
                        .find('.img-zoomOut')
                        .click(function () {
                            RVwys.fixBlockTools();
                            curImage.cropper('zoom', '-0.1');
                        })
                        .end()
                        .find('.img-rotate')
                        .click(function () {
                            RVwys.fixBlockTools();
                            curImage.cropper('rotate', '45');
                        })
                        .end()
                        .find('.oriSize')
                        .click(function () {
                            // alert('ori ative')
                            RVwys.fixBlockTools();
                            curImage.cropper('destroy');
                            RVwys.enableSlideshow();
                            if (curImage.attr('srcNew')) {
                                curImage.attr('src', curImage.attr('srcNew'));
                            } else {
                                curImage.attr('src', curImage.srcdefault);
                            }
                            curImage.width('');
                            curImage.height('');
                            curImage.css({
                                width: '',
                                height: '',
                            });
                            $('.overlaypanel').remove();
                            parent.$('.overlaypanel').remove();
                            $('.overlay-image').remove();
                            parent.$('.overlay-image').remove();
                            curImage.imageReEdit(this, $(this).is(':checked'));
                        })
                        .end()
                        .find('.img-flipHor')
                        .click(function () {
                            RVwys.fixBlockTools();
                            var oIm = curImage.cropper('getImageData');
                            var x = !oIm.scaleX ? 1 : oIm.scaleX;
                            curImage.cropper('scaleX', x * -1);
                        })
                        .end()
                        .find('.img-flipVer')
                        .click(function () {
                            RVwys.fixBlockTools();
                            var oIm = curImage.cropper('getImageData');
                            var y = !oIm.scaleY ? 1 : oIm.scaleY;
                            curImage.cropper('scaleY', y * -1);
                        })
                        .end()
                        .find('.img-info')
                        .click(function () {
                            RVwys.fixBlockTools();
                            $('.img-info-view')
                                .find('span')
                                .eq(0)
                                .toggleClass('inlinehelpOver');
                        })
                        .end()
                        .find('.img-full')
                        .click(function () {
                            var src = curImage.attr('src');
                            parent.editorImage = false;
                            RVwys.parallaxStart();
                            $('#imedit-upload').val('');
                            curImage.cropper('destroy');
                            RVwys.enableSlideshow();
                            curImage.attr('src', oDefault.srcdefault);

                            curImage.removeAttr('srcNew');
                            curImage.removeAttr('srcdefault');
                            curImage.removeAttr('defaultWidth');
                            curImage.removeAttr('defaultHeight');

                            var oLoad = $(
                                '<img class="loading" src="' +
                                    parent.wex.url.WYS_IMG_URL +
                                    'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />'
                            );
                            $('.overlaypanel').append(oLoad);
                            parent.RVwys.imageEditorFullAndInsert(src);
                        });
                    $(document).one('keyup', function (e) {
                        if (e.keyCode === 27) {
                            RVwys.fixBlockTools();
                            $('.img-cancel').trigger('click');
                        }
                    });
                    // display: image editor position
                    var imgPos = {
                        left: { margin: '0' },
                        '-webkit-left': { margin: '0' },
                        '-moz-left': { margin: '0' },
                        start: { margin: '0' },
                        '-webkit-start': { margin: '0' },
                        '-moz-start': { margin: '0' },
                        center: { margin: '0 auto' },
                        '-webkit-center': { margin: '0 auto' },
                        '-moz-center': { margin: '0 auto' },
                        right: { margin: '0 0 0 auto' },
                        '-webkit-right': { margin: '0 0 0 auto' },
                        '-moz-right': { margin: '0 0 0 auto' },
                        end: { margin: '0 0 0 auto' },
                        '-webkit-end': { margin: '0 0 0 auto' },
                        '-moz-end': { margin: '0 0 0 auto' },
                        undefined: false,
                    };
                    var k = curImage.parent().css('text-align');
                    var curIm = curImage.offset();
                    var isBanner = curImage
                        .closest('#selected_headerbanner')
                        .get(0);
                    var aCss = isBanner
                        ? {
                              position: 'fixed',
                              top: '27px',
                              left: oDefault.left,
                          }
                        : {
                              position: 'absolute',
                              top: oDefault.top,
                              left: oDefault.left,
                          };

                    var rvCropperContainer = curImage
                        .parent()
                        .find('.cropper-container')
                        .css(aCss);
                    if (k) {
                        rvCropperContainer.css(imgPos[k]);
                    }
                    rvCropperContainer.prepend(oDefault.button).show();
                    $('.overlaypanel').find('.loading').remove();
                    if (imageType == 'gif') {
                        $('.img-info-view')
                            .find('span')
                            .eq(0)
                            .toggleClass('inlinehelpOver');
                    }
                    var posWEditor = rvCropperContainer
                        .find('.cropper-icon-image-editor')
                        .width();
                    var offsetWEditor =
                        rvCropperContainer.offset().left + posWEditor;
                    // console.log('editor ->'+offsetWEditor)
                    if (offsetWEditor > window.innerWidth) {
                        var setoffEditor = window.innerWidth - offsetWEditor;
                        // console.log('setoffEditor'+setoffEditor);
                        rvCropperContainer
                            .find('.cropper-icon-image-editor')
                            .css('margin-left', +setoffEditor);
                    }

                    $.when(
                        $('html, body').animate(
                            {
                                scrollTop:
                                    rvCropperContainer
                                        .find('.cropper-icon-image-editor')
                                        .offset().top - 80,
                            },
                            500,
                            function () {
                                rvCropperContainer
                                    .find('.cropper-icon-image-editor')
                                    .show();

                                // rvCropperContainer.find('.cropper-icon-image-editor').offset().top.get(0).focus();
                                // RVwys.imageEditorToolResetPos();
                            }
                        )
                    ).then(function () {
                        var isEditable = curImage
                            .closest('.RVWYSIWYGAREA')
                            .get(0);
                        //  fast PC
                        $(isEditable).css({
                            transform: 'unset',
                            opacity: 'unset',
                        });
                        setTimeout(function () {
                            // slow PC
                            $(isEditable).css({
                                transform: 'unset',
                                opacity: 'unset',
                            });
                        }, 1000);
                    });

                    // console.log('editor ->
                    // width'+rvCropperContainer.find('.cropper-icon-image-editor').width())
                },
            });
        };
    };

    $.fn.imageReChoose = function (input) {
        if (!AjaxImgLoad) {
            // RVwys.fixBlockTools();
            //TODO: ค่อยปรับตอนโหลดให้เหมาะสมว่าจะโหลดตอนไหน
            //แก้ปัญหารูปไม่ขึ้น
            console.log('ready call ajax buildimagesjson:');
            AjaxImgLoad = $.ajax({
                method: 'GET',
                url: parent.wex.route_action.routeCommonBuildimages,
                dataType: 'html',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                        'content'
                    ),
                },
            });
        }

        console.log(parent.aFreeImages);
        parent.focusImage = curImage;
        // RVwys.imagemanager.show();
        parent.$('.imageLib').show();
        parent.RVwys.hidePanelAll();
        $('.imgEditor').hide();
        RVwys.currentImageManager(curImage, 'active');
        $('.image-editor-tool')
            .find('#imedit-reEdit,#imedit-rechoose,#imedit-edit')
            .hide();
    };

    function uploadProgress(evt, imgJSON) {
        var progress;
        if (evt.lengthComputable) {
            progress = Math.round((evt.loaded * 100) / evt.total);
        } else {
            progress = 'unable to compute';
        }

        if (progress > 99) {
            progress = 99;
        }

        if (imeload) {
            imeload.set(progress);
        }

        var head = '';
        if (imgJSON.send.imageURL) {
            head += 'imageURL' + imgJSON.send.imageURL;
        }
        head += 'saveImagervwysiwyguikitdata:image/jpeg;base64';
        // alert(head)
        var totalKB = Math.round((evt.total - head.length) / 1024);
        var perSEC = Math.round((evt.loaded - head.length) / 1024);
        var totalMB = Math.round(totalKB / 1024);
        var SEC = 'KB';
        var showTotal = totalKB + 'KB';
        if (totalKB >= 1000) {
            showTotal = (totalKB / 1024).toFixed(2) + 'MB';
            perSEC = (perSEC / 1024).toFixed(2) + 'MB';
        } else {
            perSEC = perSEC + SEC;
        }
        console.log('perSEC' + perSEC);
        imgJSON.overlay.find('.msgupload-image').html(perSEC + '|' + showTotal);
    }

    function uploadComplete(evt, imgJSON, xhr) {
        if (imeload) {
            imeload.set(100);
        }
        var d = new Date();
        var n = d.getTime();

        var data = jQuery.parseJSON(xhr.responseText);
        if (parent.myimages) {
            Object.assign(parent.myimages, data.myimages);
        } else {
            parent.myimages = data.myimages;
        }
        if (parent.storeimages) {
            Object.assign(parent.storeimages, data.storeimages);
        } else {
            parent.storeimages = data.storeimages;
        }
        console.log(parent.myimages);
        data.src = data.src + '?n=' + n + 'set';
        $('.overlaypanel').remove();
        parent.$('.overlaypanel').remove();

        $('.overlay-image').remove();
        imgJSON.overlay.remove();
        imgJSON.image.attr('src', data.src);
        imgJSON.image.removeAttr('srcNew');
        imgJSON.image.removeAttr('srcdefault');
        imgJSON.image.removeAttr('defaultWidth');
        imgJSON.image.removeAttr('defaultheight');
        imgJSON.image.removeAttr('width');
        imgJSON.image.removeAttr('height');
        imgJSON.image.css({
            width: '',
            height: '',
        });

        // alert(parent.$('body').html())
        // alert(parent.$('#tagfolderJS').attr('src'))
        $('#imedit-upload').val('');
        parent.$('.myImageJSON').each(function () {
            var src = $(this)
                .attr('src')
                .replace(/\?n=\w*/gim, '');

            $(this).attr('src', src + '?n=' + n);
        });

        var imageName = data.name;
        var urlImage = data.src;
        var imagekey = data.imagekey;
        console.log('imageName->' + urlImage);
        var imageItemHTML = parent.$('#designMyImageItem').html();
        var oImageItem = $(imageItemHTML);
        oImageItem.find('.insert').attr('data', urlImage);
        oImageItem
            .find('.remove')
            .attr({ imagename: imageName, imagekey: imagekey });
        var attr = { src: urlImage, id: 'my' + imageName };
        // Object.assign(attr, parent.myimages[imageKey]);
        parent.$('.workspace').html('');
        parent.$('#imageLib-tabs').tabs('option', 'active', 0);

        oImageItem.find('.imageItems').attr(attr);
        oImageItem = RVwys.imagemanager.eventMyImage(oImageItem);
        if (imgJSON.send.override) {
            var id = imageName.replace('.', '\\.');
            if (
                parent
                    .$('.imageBoxView-myimage')
                    .find('#my' + id)
                    .get(0)
            ) {
                parent
                    .$('.imageBoxView-myimage')
                    .find('#my' + id)
                    .parent()
                    .replaceWith(oImageItem);
            } else {
                if (parent.$('.workspace').html() != '') {
                    parent
                        .$('.imageBoxView-myimage')
                        .find('.workspace')
                        .prepend(oImageItem);
                    oImageItem = RVwys.imagemanager.eventMyImage(oImageItem);
                }
            }
        } else {
            if (parent.$('.workspace').html() != '') {
                parent
                    .$('.imageBoxView-myimage')
                    .find('.workspace')
                    .prepend(oImageItem);
                // alert(parent.$('.imageBoxView-myimage').find('#my'+imageName).get(0))
                oImageItem = parent.RVwys.imagemanager.eventMyImage(oImageItem);
            }
        }
    }

    /**
     * var sendImage = { image:curImage, overlay:overlayImg, send:{
     * 'data':imageData, 'thumnail':thumbnail, 'imageURL':imageURL,
     * 'override':isOverride, 'imageName':imageName, 'imageType':imageType,
     * 'tagFolder':'' } } da: call API CMD_API_FILE_MANAGER $option =
     * array('action' => 'edit' ,'path' =>
     * '/.rvsitebuilder/projects/091e3fb1738d68bf737953f0e3193711/images'
     * ,'text' => $images_data ,'filename' => 'header_banner.txt'
     */

    function uploadImageDA(evt, imgJSON) {
        var fd = new FormData();
        fd.append('rvsMgr', 'rvwysiwyguikit');
        fd.append('rvsAct', 'saveImage');
        fd.append('thumnail', '');
        fd.append('tagFolder', '');
        fd.append('imageURL', imgJSON.send.imageURL);
        fd.append('override', imgJSON.send.isOverride);
        fd.append('imageName', imgJSON.send.imageName);
        fd.append('imageType', imgJSON.send.imageType);
        var xhr = new XMLHttpRequest();
        // xhr.setRequestHeader("Content-type",
        // "application/x-www-form-urlencoded");
        // req.setRequestHeader( "Content-type",
        // "application/x-www-form-urlencoded" );

        xhr.addEventListener(
            'load',
            function (evt) {
                uploadComplete(evt, imgJSON, this);
            },
            false
        );

        var wysurlDa = parent.UPLOAD_DIRECTADMIN_URL;
        var wysurl = parent.RVS_AJAX_INDEX;
        wysurl = wysurl.replace('rvwysiwyguikit', 'sitebuilder');
        console.log('==> Request Url: ' + wysurl);
        xhr.open('POST', wysurl);
        xhr.send(fd);
    }
    function uploadThumnailDA(evt, imgJSON) {
        var daRequest2 = new XMLHttpRequest();
        var thumbanilData = imgJSON.send.thumnail.replace(
            /^data:image\/(png|jpg|gif|bmp);base64,/,
            '',
            ''
        );
        // rewrite data for thumbanil
        var daForm2 = new FormData();
        daForm2.append('action', 'edit');
        daForm2.append('path', '/.rvsitebuilder/tmp/');
        daForm2.append('text', thumbanilData);
        daForm2.append('filename', 'images_data_thumbnail.txt');
        // daRequest 2
        var wysurlDa = parent.UPLOAD_DIRECTADMIN_URL;
        daRequest2.open('POST', wysurlDa);
        daRequest2.addEventListener(
            'load',
            function (evt) {
                uploadImageDA(evt, imgJSON, this);
            },
            false
        );
        daRequest2.send(daForm2);
    }
    function uploadImage(imgJSON) {
        console.log('fn: imageEditor.uploadImage(imgJSON)');
        var fd = new FormData();
        //        fd.append('rvsMgr','rvwysiwyguikit');
        //        fd.append('rvsAct','saveImage');
        console.log(imgJSON);

        // case: cpanel mode set form value
        $.each(imgJSON.send, function (k, v) {
            console.log('k: ' + k + ' length: ' + v.length);
            fd.append(k, v);
        });

        fd.append('_token', $('meta[name="csrf-token"]').attr('content'));
        // TODO:: Convert xhr to axios axiosSaveImage
        var xhr = new XMLHttpRequest();
        // xhr.setRequestHeader("Content-type",
        // "application/x-www-form-urlencoded");
        // req.setRequestHeader( "Content-type",
        // "application/x-www-form-urlencoded" );

        xhr.upload.addEventListener(
            'progress',
            function (evt) {
                uploadProgress(evt, imgJSON);
            },
            false
        );

        xhr.addEventListener(
            'load',
            function (evt) {
                uploadComplete(evt, imgJSON, this);
            },
            false
        );
        // xhr.addEventListener("error", uploadFailed, false);
        // xhr.addEventListener("abort", uploadCanceled, false);
        //            var wysurl = parent.RVS_AJAX_INDEX;
        //            wysurl = wysurl.replace('rvwysiwyguikit','sitebuilder');
        //            console.log('==> Request Url: ' + wysurl);
        //alert(parent.wex.route_action.routeCommonSaveImage)
        xhr.open('POST', parent.wex.route_action.routeCommonSaveImage);
        xhr.send(fd);
    }

    $.fn.imageReEdit = function (input, ori = false) {
        RVwys.disableSlideshow();
        var isBanner = curImage.closest('#selected_headerbanner').get(0);
        var isEditable = curImage.closest('.RVWYSIWYGAREA').get(0);
        $('.rv-zindex-auto').removeClass('rv-zindex-auto');
        $('[class^="uk-width"][style*="z-index"]').addClass('rv-zindex-auto');
        RVwys.fixBlockTools();
        // $('.imgEditor').hide();
        parent.RVwys.hidePanelAll();
        var overlaypanel = $(
            '<div class="overlaypanel">' +
                '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                '</div>'
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });
        if (isBanner) {
            $('#selected_headerbanner').css({ 'z-index': 'unset' });
        }

        $(isEditable).css({ transform: 'unset', opacity: 'unset' });

        /*	$(isEditable).after($('<div class="overlaypanel">'
			+'<img class="loading" src="'
			+ parent.wex.url.rvsThemImage
			+ 'loading08.gif" width="32" height="32" border="0" align="absmiddle" />'
			+'</div>').css({
				'width':$('body').width(),
				'height':$('body').height()
			}))*/
        //$('.uk-slideshow').append(overlaypanel.clone())
        $('body').prepend(overlaypanel);
        /*
         */
        parent.$('body').prepend(
            $('<div class="overlaypanel"></div>').css({
                width: parent.$('#topbar').width() + 1,
                height: parent.$('#topbar').height() + 1,
            })
        );
        $('.layoutResize').remove();
        var aImageURL = curImage.attr('src').split('/');
        var name = aImageURL[aImageURL.length - 1].replace(/\?(.*)/gim, ''); // .replace('.','');

        // alert(curImage.get(0).src.match(/http/img))
        //
        if (!ori) {
            var setWidth = curImage.attr('defaultWidth') || curImage.width();
            var setHeight = curImage.attr('defaultHeight') || curImage.height();
            var Msrcs = curImage.attr('srcdefault')
                ? curImage.attr('srcdefault')
                : curImage.attr('src');

            curImage.attr({
                srcdefault: Msrcs,
                defaultWidth: setWidth,
                defaultHeight: setHeight,
            });
            if (curImage.attr('srcNew')) {
                imgEditor.init(name, curImage.attr('srcNew'), ori);
            } else {
                if (curImage.attr('srcdefault')) {
                    imgEditor.init(name, curImage.attr('srcdefault'), ori);
                } else {
                    imgEditor.init(name, curImage.get(0).src, ori);
                }
            }
        } else {
            if (curImage.attr('srcNew')) {
                imgEditor.init(name, curImage.attr('srcNew'), ori);
            }
            imgEditor.init(name, curImage.attr('srcdefault'), ori);
        }
    };

    $.fn.imageUpload = function (input) {
        // alert('sssdfs'+$(input).val())
        RVwys.fixBlockTools();
        var fileType = ['.jpg', '.jpeg', '.bmp', '.gif', '.png'];
        var pat = new RegExp('(' + fileType.join('|') + ')$', 'img');
        var isFileType = pat.exec($(input).val());
        if (!isFileType) {
            var UI = parent.UIkit;
            var onInsert = function (e) {
                $('#imedit-upload').val('');
                parent.$('#imedit-upload').val('');
                modal.hide();
            };
            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Upload image') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        rvLang('file type not support.') +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Ok') +
                        '</button>',
                    '</div>',
                ].join(''),
                options
            );
            modal.element.find('.uk-button-success').on('click', function () {
                onInsert();
            });
            modal.show();
            $(input).val('');
            return false;
        }

        $('.imgEditor').hide();

        parent.$('body').prepend(
            $('<div class="overlaypanel"></div>').css({
                width: parent.$('.rvinner-wrapper').width() + 1,
                height: parent.$('.rvinner-wrapper').height() + 1,
            })
        );
        var overlaypanel = $('<div class="overlaypanel"></div>').css({
            width: $('body').width(),
            height: $('body').height(),
        });

        parent.RVwys.hidePanelAll();
        $('body').prepend(overlaypanel);
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            var getThis = $(this);
            reader.onload = function (e) {
                var defaultWidth = curImage.width();
                var defaultHeight = curImage.height();
                var srcdefault = curImage.attr('src');
                curImage.attr({
                    src: e.target.result,
                    srcdefault: srcdefault,
                    defaultWidth: defaultWidth,
                    defaultHeight: defaultHeight,
                });
                console.log('before init width:' + defaultWidth);
                console.log('before init height:' + defaultWidth);
                imgEditor.init(name, e.target.result);
            };
            reader.readAsDataURL(input.files[0]);
        } else {
            swal("Sorry - you're browser doesn't support the FileReader API");
        }
    };

    RVwys.designViewAddEvent('mouseup', RVwys.imageEditorEventmUp);

    if (!parent.editorImage) {
        RVwys.fixBlockTools();
        var UKWidth = $(RVwys.currentiFrame).closest('div[class*=uk-width]');
        UKWidth.css('position', 'relative');
    }

    RVwys.designViewAddEvent('mousedown', function (e) {
        if (
            ($(e.target).prop('tagName').toLowerCase() == 'div' ||
                $(e.target).prop('tagName').toLowerCase() == 'p') &&
            parent.$('#Gridline').attr('act') == 'onGridline' &&
            parent.$('#pasteButton').attr('act') == 'notActive'
        ) {
            $(e.target).not('div.editorCurrent').addClass('GridLine');
        }
    });
})(jQuery);
